import { createSelector } from 'reselect'

import { selectCockpitMode } from './selectCockpitMode'
import { selectCockpitPartnerData } from './selectCockpitPartnerData'
import { selectFilteredCockpitPartnerData } from './selectFilteredCockpitPartnerData'

export const selectVisibleCockpitPartnerData = createSelector(
  [selectCockpitMode, selectCockpitPartnerData, selectFilteredCockpitPartnerData],
  (cockpitMode, partnerData, filteredPartnerData) =>
    cockpitMode === 'manager' ? filteredPartnerData : partnerData
)
